import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';
import { useApp } from '../context/AppContext';
import CurrencySelector from './CurrencySelector';
import LanguageSelector from './LanguageSelector';
import { useTranslation } from '../hooks/useTranslation';

const Header: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { isAuthenticated, user, logoutUser } = useApp();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleSignOut = () => {
        logoutUser();
        navigate('/');
    };

    return (
        <motion.header 
            className="header"
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
        >
            <div className="container">
                <div className="header-content">
                    {/* Logo */}
                    <Link to="/" className="logo">
                        <motion.div 
                            className="logo-icon"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            ✈️
                        </motion.div>
                        <div className="logo-text">
                            <h1>MB Tourism</h1>
                            <span className="logo-subtitle">Discover Your Adventure</span>
                        </div>
                    </Link>

                    {/* Navigation */}
                                    <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
                    <ul className="nav-list">
                        <li><Link to="/" className="nav-link nav-box">الرئيسية</Link></li>
                        <li><Link to="/destinations" className="nav-link nav-box">الوجهات</Link></li>
                        <li><Link to="/hotels" className="nav-link nav-box">الفنادق</Link></li>
                        <li><Link to="/partner-hotels" className="nav-link nav-box">الفنادق الشريكة</Link></li>
                        <li><Link to="/flights" className="nav-link nav-box">الطيران</Link></li>
                        <li><Link to="/packages" className="nav-link nav-box">الباقات</Link></li>
                        <li><Link to="/about" className="nav-link nav-box">حولنا</Link></li>
                    </ul>
                </nav>

                    {/* User Actions */}
                    <div className="user-actions">
                        {!isAuthenticated ? (
                            <>
                                <motion.button 
                                    className="btn btn-secondary"
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    onClick={() => navigate('/login')}
                                >
                                    تسجيل الدخول
                                </motion.button>
                                <motion.button 
                                    className="btn btn-accent"
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    onClick={() => navigate('/register')}
                                >
                                    إنشاء حساب
                                </motion.button>
                                <motion.button 
                                    className="btn btn-primary"
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    onClick={() => navigate('/packages')}
                                >
                                    {t('nav.bookNow')}
                                </motion.button>
                                
                                {/* Language & Currency Selectors */}
                                <div className="header-selectors">
                                    <CurrencySelector />
                                    <LanguageSelector />
                                </div>
                            </>
                        ) : (
                            <div className="user-menu">
                                <span className="text-gray-700" style={{ marginRight: 8 }}>
                                    {t('nav.hi')}, {user?.name}
                                </span>
                                <Link to="/account" className="btn btn-secondary" style={{ marginRight: 8 }}>
                                    {t('nav.myAccount')}
                                </Link>
                                <motion.button 
                                    className="btn btn-primary"
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    onClick={handleSignOut}
                                >
                                    {t('nav.signOut')}
                                </motion.button>
                                
                                {/* Language & Currency Selectors */}
                                <div className="header-selectors">
                                    <CurrencySelector />
                                    <LanguageSelector />
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Mobile Menu Button */}
                    <button 
                        className={`mobile-menu-btn ${isMenuOpen ? 'active' : ''}`}
                        onClick={toggleMenu}
                        aria-label="Toggle menu"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </div>
        </motion.header>
    );
};

export default Header;
